import { Component, ChangeDetectionStrategy, input } from '@angular/core';


@Component({
    selector: 'app-agent-information',
    templateUrl: './agent-information.component.html',
    imports: [],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AgentInformationComponent {

  readonly agentData = input<any>(null);

}
